module.exports = __webpack_public_path__ + "images/favicon-196x196-465612f5f3e0d00d721c779e789b7beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/favicon-196x196.png
// module id = ./src/images/favicons/favicon-196x196.png
// module chunks = 1